/**
 * eon-shop-grid.js — THE EON WEAR / Home shop grid
 * Long-press (touch-and-hold) para previsualizar la segunda imagen de
 * producto en dispositivos táctiles. En mouse, el crossfade ya lo resuelve
 * el hover CSS (.eon-product-card:hover, ver eon-home.css); este script
 * ignora explícitamente los eventos cuyo pointerType no sea "touch" para
 * no tocar ese comportamiento.
 */
(function () {
  "use strict";

  if (!window.PointerEvent) return;

  var LONG_PRESS_MS = 300;
  var MOVE_THRESHOLD = 10;

  function initCard(link) {
    if (link.dataset.eonBound === "true") return;

    var card = link.closest(".eon-product-card");
    if (!card || !card.querySelector(".eon-product-card__image--secondary")) return;

    link.dataset.eonBound = "true";

    var timer = null;
    var startX = 0;
    var startY = 0;
    var moved = false;
    var previewing = false;
    var suppressNextClick = false;

    function clearTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function startPreview() {
      timer = null;
      previewing = true;
      card.classList.add("is-previewing");
    }

    function endPreview() {
      previewing = false;
      card.classList.remove("is-previewing");
    }

    link.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "touch") return;
      moved = false;
      startX = event.clientX;
      startY = event.clientY;
      clearTimer();
      timer = setTimeout(startPreview, LONG_PRESS_MS);
    });

    link.addEventListener("pointermove", function (event) {
      if (event.pointerType !== "touch" || moved) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.sqrt((dx * dx) + (dy * dy)) > MOVE_THRESHOLD) {
        moved = true;
        clearTimer();
        if (previewing) endPreview();
      }
    });

    link.addEventListener("pointerup", function (event) {
      if (event.pointerType !== "touch") return;
      clearTimer();
      if (previewing) {
        endPreview();
        suppressNextClick = true;
      }
    });

    link.addEventListener("pointercancel", function (event) {
      if (event.pointerType !== "touch") return;
      clearTimer();
      if (previewing) endPreview();
    });

    link.addEventListener("pointerleave", function (event) {
      if (event.pointerType !== "touch") return;
      clearTimer();
      if (previewing) endPreview();
    });

    link.addEventListener("click", function (event) {
      if (suppressNextClick) {
        suppressNextClick = false;
        event.preventDefault();
      }
    });
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll(".eon-product-card__link").forEach(initCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    if (!section.querySelector(".eon-product-card__link")) return;
    initAll(section);
  });
})();
